/**
 * Canonical PII-bearing selectors for support widget screenshot auto-masking.
 *
 * Used by ScreenshotCapture.jsx to overlay grey rectangles on elements likely
 * to contain personal data (salaries, candidate full names, contacts, passport
 * numbers) before the screenshot leaves the browser.
 *
 * Preferred annotation: `data-pii="true"` on the element directly.
 * Legacy class selectors are kept as fallback for components not yet annotated.
 *
 * Initiative: docs/specs/support-agent-onboardix-2026q2-pr2-widget/plan.md
 */

export const PII_MASKED_SELECTORS = [
    '[data-pii="true"]',
    '[data-pii-mask]',
    '[data-passport]',
    '[data-phone-number]',
    '[data-email-address]',
    // legacy class selectors (covered by T11 audit-chore)
    '.salary-cell',
    '.candidate-contact',
    '.personnel-section.compensation',
    '.personnel-section.medical',
    '.personnel-section.disciplinary',
]

export const PII_MASK_FILL = 'rgba(120, 120, 120, 0.92)'
